module.exports = __webpack_public_path__ + "static/media/compare_93.2fd0dee4.svg";